// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var RECOMMENDATIONS_SELECTOR = '.product-recommendations';

// Style includes
import './_product-recommendations.scss';

// -------------------------------------
// Helpers
// -------------------------------------

var initProductRecommendations = () => {
  var productRecommendations = document.querySelectorAll(RECOMMENDATIONS_SELECTOR);
  productRecommendations.forEach(productRecommendation => {
    var observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px'
    });
    observer.observe(productRecommendation);
  });
};
var handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  var $elem = entries[0].target;
  var url = $elem.dataset.url;
  observer.unobserve($elem);
  fetch(url).then(response => response.text()).then(text => {
    var html = document.createElement('div');
    html.innerHTML = text;
    var recommendations = html.querySelector(RECOMMENDATIONS_SELECTOR);
    if (recommendations && recommendations.innerHTML.trim().length) {
      $elem.innerHTML = recommendations.innerHTML;
    }
  }).catch(e => {
    console.error(e);
  });
};

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  initProductRecommendations();
});